import { Feature, Polygon, MultiPolygon } from "@turf/turf";
import {
  basePointLayerStyle,
  basePolygonLayerStyle,
  deleteLayerStyle,
  editLayerStyle,
} from "config/geometryStyles";
import { Layer } from "leaflet";
import { Measure, MeasureConf } from "types/types";

export function isGeomanLayer(layer: Layer | L.GeoJSON): layer is Layer {
  return layer.hasOwnProperty("_latlngs") || layer.hasOwnProperty("_latlng");
}

export function getGeojsonFeature(
  layer: L.GeoJSON | Layer
): Feature<Polygon | MultiPolygon> {
  // Layer will be treated as a geomanlayer, even when the layer wasn't created by geoman
  if (isGeomanLayer(layer)) {
    //@ts-ignore
    return layer.toGeoJSON(false);
  }
  //@ts-ignore
  const geoJsonPolygon = layer.toGeoJSON(false).features;

  const [firstPolygon] = geoJsonPolygon;

  return { ...firstPolygon };
}

export function applyPointLayerStyle(layer: Layer, measureConfig: MeasureConf) {
  //@ts-ignore
  layer.setStyle({
    ...basePointLayerStyle,
    color: measureConfig.measure.color,
    fillColor: measureConfig.measure.hasTrunk
      ? `url(#${measureConfig.measure.name})`
      : measureConfig.measure.color,
  });
}

export function applyPointLayerHighlightStyle(
  layer: Layer,
  measureConfig: MeasureConf
) {
  //@ts-ignore
  layer.setStyle({
    ...basePointLayerStyle,
    color: measureConfig.measure.color,
    fillColor: measureConfig.measure.hasTrunk
      ? `url(#${measureConfig.measure.name}-trunk-highlight)`
      : `url(#${measureConfig.measure.name}-highlight)`,
  });
}

export function applyPolygonLayerStyle(
  layer: Layer,
  measureConfig: MeasureConf
) {
  //@ts-ignore
  layer.setStyle({
    ...basePolygonLayerStyle,

    color: measureConfig.measure.color,
    fillColor: measureConfig.measure.color,
  });
}

export function applyPolygonLayerHighlightStyle(
  layer: Layer,
  measureConfig: MeasureConf
) {
  //@ts-ignore
  layer.setStyle({
    ...basePolygonLayerStyle,
    color: "red",
    fillColor: measureConfig.measure.color,
  });
}

export function applyPointRadius(layer: Layer, radius: number) {
  // @ts-ignore
  layer.eachLayer((layer) => {
    if (radius) return layer.setRadius(radius);
  });
}

export function resetPointLayerStyle(layer: Layer, measure: Measure) {
  // @ts-ignore
  layer.setStyle({
    ...basePointLayerStyle,
    color: measure.color,
    fillColor: measure.hasTrunk ? `url(#${measure.name})` : measure.color,
  });
}

export function applyEditLayerStyle(layer: Layer) {
  // @ts-ignore
  layer.setStyle({
    ...editLayerStyle,
    zIndex: 9999,
  });
}

export function applyDeleteLayerStyle(layer: Layer) {
  // @ts-ignore
  layer.setStyle({
    ...deleteLayerStyle,
    zIndex: 9999,
  });
}

export function resetPolygonLayerStyle(layer: Layer, measure: Measure) {
  // @ts-ignore
  layer.setStyle({
    ...basePolygonLayerStyle,
    color: measure.color,
    fillColor: measure.color,
  });
}
